module.exports = __webpack_public_path__ + "img/062.dab42fa6.jpg";